import {createIframeForm, IFRAME_STYLES, injectCss} from "./iframe";

export const handlePrecondition = ({ index, url, method = 'POST', params = {}, stylesObj = IFRAME_STYLES,}) => {
    return new Promise((resolve, reject) => {
        const iframe = document.createElement('iframe');
        iframe.id = `precondition-iframe-${index}`;
        iframe.src = 'about:blank';
        iframe.frameBorder = '0';
        injectCss(iframe, stylesObj);
        document.querySelector('body').appendChild(iframe);
        iframe.contentDocument.write(
            createIframeForm({
                index,
                url,
                method,
                params
            }),
        );
        iframe.onload = () => {
            resolve();
        };
        iframe.onerror = () => {
            reject();
        };
        iframe.contentWindow.document.querySelector('form').submit();
    });
};